module.exports = __webpack_public_path__ + "static/media/psychology-enrolled.ecd85210.svg";